import './index.css';
import { StrictMode, Suspense, useEffect } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import appConfig from '@frontend/env';
import { useFetch } from '@frontend/fetch';
import { LocationServiceProvider } from '@frontend/wam-location-service';
import { AlertsProvider, ModalSingletonProvider, ThemeProvider } from '@frontend/design-system';
import { AuthProvider } from './providers/auth.provider';
import { LayoutProvider } from './providers/layout.provider';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const root = createRoot(document.getElementById('root')!);

const Root = () => {
  console.log('version: - ', appConfig.VERSION);
  const { setBaseUrl } = useFetch();

  useEffect(() => {
    setBaseUrl(appConfig.BACKEND_API);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider includeEmotionTheme>
        <LocationServiceProvider>
          <ModalSingletonProvider>
            <AlertsProvider>
              <AuthProvider>
                <LayoutProvider>
                  <RouterProvider router={router} />
                </LayoutProvider>
              </AuthProvider>
            </AlertsProvider>
          </ModalSingletonProvider>
        </LocationServiceProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

root.render(
  <StrictMode>
    <Suspense fallback='loading'>
      <Root />
    </Suspense>
  </StrictMode>
);
